module.exports = __webpack_public_path__ + "img/icon-element-Polearm.093acd1b.webp";